import { render } from "./cvView-10.vue?vue&type=template&id=62d21224&scoped=true"
import script from "./cvView-10.vue?vue&type=script&lang=js"
export * from "./cvView-10.vue?vue&type=script&lang=js"

import "./cvView-10.vue?vue&type=style&index=0&id=62d21224&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d21224"]])

export default __exports__